export const buttonsComponentView = () => {
    return `
    <div class="app-ecommerce-product-buy-buttons-wrapper"></div>
  `;
};
